export default {
      id: "logo_alt-usage",
      viewBox: "0 0 277 96",
      url: __webpack_public_path__ + "svg/sprite.svg#logo_alt",
      toString: function () {
        return this.url;
      }
    }